import { cargoTypeConstants } from '../../_constants';
import { cargoTypeServices } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const cargoTypeActions = {
    getCargoTypes,
    getCargoTypeById,
    createCargoType,
    updateCargoType,
    deleteCargoTypes,
    activation,
    getActiveCargoTypes,
};

function cargoTypeFetching() { return { type: cargoTypeConstants.CARGO_TYPE_FETCHING } }
function cargoTypeFetched() { return { type: cargoTypeConstants.CARGO_TYPE_FETCHED } }

function cargoTypeSubmitting() { return { type: cargoTypeConstants.CARGO_TYPE_SUBMITTING } }
function cargoTypeSubmitted() { return { type: cargoTypeConstants.CARGO_TYPE_SUBMITTED } }

function getCargoTypes(skip, take, filter, search) {
    return dispatch => {
        dispatch(cargoTypeFetching());
        dispatch(userActions.allowLeavePage());
        cargoTypeServices.getCargoTypes(skip, take, filter, search)
            .then(
                cargoTypes => {
                    if (cargoTypes.length > 0) {
                        dispatch(success(cargoTypes));
                        dispatch(cargoTypeFetched());
                    } else {
                        dispatch(cargoTypeFetched());
                        dispatch(alertActions.warning(cargoTypes.message))
                    }
                },
                error => {
                    dispatch(cargoTypeFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(cargoTypes) { return { type: cargoTypeConstants.GET_CARGO_TYPES, cargoTypes } }
}
function getCargoTypeById(id) {
    return dispatch => {
        dispatch(cargoTypeFetching());
        dispatch(userActions.allowLeavePage());
        cargoTypeServices.getCargoTypeById(id)
            .then(
                cargoType => {
                    dispatch(success(cargoType))
                    dispatch(cargoTypeFetched());
                },
                error => {
                    dispatch(cargoTypeFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(cargoType) { return { type: cargoTypeConstants.GET_CARGO_TYPE_BY_ID, cargoType } }
}
function createCargoType(payload) {
    return dispatch => {
        dispatch(cargoTypeSubmitting());
        dispatch(userActions.notallowLeavePage());
        cargoTypeServices.createCargoType(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(cargoTypeSubmitted());
                    dispatch(alertActions.success('Cargo type added successfully'));
                    window.location.href = '/master_data/cargo_types';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(cargoTypeSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateCargoType(payload, id) {
    return dispatch => {
        dispatch(cargoTypeSubmitting());
        dispatch(userActions.notallowLeavePage());
        cargoTypeServices.updateCargoType(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(cargoTypeSubmitted());
                    dispatch(alertActions.success('Cargo type updated successfully'))
                    window.location.href = '/master_data/cargo_types';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(cargoTypeSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function deleteCargoTypes(id, type, take) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        cargoTypeServices.deleteCargoTypes(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Cargo types deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/cargo_types';
                            break;
                        default:
                            dispatch(getCargoTypes(0, take));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                    switch (type) {
                        case "specific":
                            dispatch(getCargoTypeById(id));
                            break;
                        default:
                            dispatch(getCargoTypes(0, take));
                            break;
                    }
                }
            );
    };
}
function activation(id, isActive) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        cargoTypeServices.activation(id, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getCargoTypeById(id));
                    dispatch(alertActions.success(isActive ? 'Cargo type activated successfully' : 'Cargo type deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function getActiveCargoTypes() {
    return dispatch => {
        cargoTypeServices.getActiveCargoTypes()
            .then(
                activeCargoTypes => dispatch(success(activeCargoTypes)),
                error => dispatch(alertActions.error(error.toString()))
            );
    };
    function success(activeCargoTypes) { return { type: cargoTypeConstants.GET_ACTIVE_CARGO_TYPES, activeCargoTypes } }
}